import { userEventsPostingDisabledShown } from '../../../actions/user-events';

export const postingDisabledModalDataLoader = userEventsPostingDisabledShown;
